"use strict";
// import { ButtonControl, LabelControl, TextInputControl } from "doshx_controls_web";
// import React, { useState } from "react";
// import { useDispatch } from "react-redux";
// import { AppDispatch } from "../../../store";
// import { setContentModal, setDrawer, setMessageModal } from "../../../reducers/slices/main";
// import { LogInComponent } from "./login";
// import { forgot_email_password } from "../../../api/calls/user/forgot_email_password";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ForgotPasswordComponent = void 0;
// export const ForgotPasswordComponent = () => {
//   const dispatch = useDispatch<AppDispatch>();
//   const [email, setEmail] = useState<string>("");
//   const [emailMesage, setEmailMessage] = useState<string>("");
//   const [isLoading, setIsLoading] = useState<boolean>(false);
//   const validate = () => {
//     let messageCount = 0;
//     setEmailMessage("");
//     if (!email) {
//       messageCount++;
//       setEmailMessage("Email is required");
//     }
//     return messageCount === 0 ? true : false;
//   };
//   return (
//     <div className="flex flex-col gap-4 h-full justify-center">
//       <div className="flex flex-col gap-4">
//         <LabelControl label="Forgot Password" size="xlarge" bold textColor="text-black" />
//         <div className="flex flex-col gap-2">
//           <LabelControl
//             label="Forgot your password? Just enter your email address below. We will send you an email containing a link for you to reset your password." //
//             size="small"
//           />
//         </div>
//         <TextInputControl
//           label="Email Address"
//           value={email}
//           onChange={(v) => {
//             setEmail(v);
//           }}
//           errorText={emailMesage}
//         />
//          <LabelControl
//             label="The link in the email is valid for 15 minutes." //
//             size="xsmall"
//           />
//         <div className="flex gap-4 justify-center w-full">
//           <div className="flex-1">
//           <ButtonControl
//             label="Reset Password"
//             loading={isLoading}
//             backgroundColor="bg-success"
//             size="small"
//             onClick={async () => {
//               if (validate()) {
//                 setIsLoading(true);
//                 forgot_email_password({
//                   email: email.trim(),
//                 }).then((response) => {
//                   setIsLoading(false);
//                   if (response.success) {
//                     dispatch(
//                       setDrawer({
//                         open: false,
//                         content: null,
//                       }),
//                     );
//                     dispatch(
//                       setMessageModal({
//                         title: "Successfully requested!",
//                         messages: ["You have successfully requested to reset your password! An email has been sent to you."],
//                       }),
//                     );
//                   } else {
//                     dispatch(setMessageModal({ title: "Something went wrong!", messages: [response.message] }));
//                   }
//                 });
//               }
//             }}
//           />
//           </div>
//           <div className="flex-1">
//           <ButtonControl
//             label="Back to Log In"
//             size="small"
//             backgroundColor="bg-primary"
//             onClick={() => {
//               dispatch(
//                 setDrawer({
//                   open: true,
//                   content: <LogInComponent />,
//                 }),
//               );
//             }}
//           />
//           </div>
//         </div>
//       </div>
//     </div>
//   );
// };
var doshx_controls_web_1 = require("doshx_controls_web");
var react_1 = __importStar(require("react"));
var react_redux_1 = require("react-redux");
var main_1 = require("../../../reducers/slices/main");
var login_1 = require("./login");
var forgot_email_password_1 = require("../../../api/calls/user/forgot_email_password");
var ForgotPasswordComponent = function () {
    var dispatch = (0, react_redux_1.useDispatch)();
    var _a = (0, react_1.useState)(""), email = _a[0], setEmail = _a[1];
    var _b = (0, react_1.useState)(""), emailMesage = _b[0], setEmailMessage = _b[1];
    var _c = (0, react_1.useState)(false), isLoading = _c[0], setIsLoading = _c[1];
    var validate = function () {
        var messageCount = 0;
        setEmailMessage("");
        if (!email) {
            messageCount++;
            setEmailMessage("Email is required");
        }
        return messageCount === 0 ? true : false;
    };
    return (react_1.default.createElement("div", { className: "flex flex-col gap-4 h-full justify-center" },
        react_1.default.createElement("div", { className: "flex flex-col gap-4" },
            react_1.default.createElement(doshx_controls_web_1.LabelControl, { label: "Forgot Password", size: "xlarge", bold: true, textColor: "text-black" }),
            react_1.default.createElement("div", { className: "flex flex-col gap-2" },
                react_1.default.createElement(doshx_controls_web_1.LabelControl, { label: "Forgot your password? Just enter your email address below. We will send you an email containing a link for you to reset your password." //
                    , size: "small" }),
                react_1.default.createElement(doshx_controls_web_1.LabelControl, { label: "The link in the email is valid for 15 minutes." //
                    , size: "xsmall" })),
            react_1.default.createElement(doshx_controls_web_1.TextInputControl, { label: "Email Address", value: email, onChange: function (v) {
                    setEmail(v);
                }, errorText: emailMesage }),
            react_1.default.createElement("div", { className: "flex gap-4 justify-center w-full" },
                react_1.default.createElement("div", { className: "flex-1" },
                    react_1.default.createElement(doshx_controls_web_1.ButtonControl, { label: "Reset Password", loading: isLoading, backgroundColor: "bg-success", size: "small", onClick: function () { return __awaiter(void 0, void 0, void 0, function () {
                            return __generator(this, function (_a) {
                                if (validate()) {
                                    setIsLoading(true);
                                    (0, forgot_email_password_1.forgot_email_password)({
                                        email: email.trim(),
                                    }).then(function (response) {
                                        setIsLoading(false);
                                        if (response.success) {
                                            dispatch((0, main_1.setDrawer)({
                                                open: false,
                                                content: null,
                                            }));
                                            dispatch((0, main_1.setMessageModal)({
                                                title: "Successfully requested!",
                                                messages: ["You have successfully requested to reset your password! An email has been sent to you."],
                                            }));
                                        }
                                        else {
                                            dispatch((0, main_1.setMessageModal)({ title: "Something went wrong!", messages: [response.message] }));
                                        }
                                    });
                                }
                                return [2 /*return*/];
                            });
                        }); } })),
                react_1.default.createElement("div", { className: "flex-1" },
                    react_1.default.createElement(doshx_controls_web_1.ButtonControl, { label: "Back to Log In", size: "small", backgroundColor: "bg-primary", onClick: function () {
                            dispatch((0, main_1.setDrawer)({
                                open: true,
                                content: react_1.default.createElement(login_1.LogInComponent, null),
                            }));
                        } }))))));
};
exports.ForgotPasswordComponent = ForgotPasswordComponent;
